module.exports = __webpack_public_path__ + "static/media/logo.201ba9db.svg";